import ReactDOM from "react-dom/client";

let loadingRoot: ReactDOM.Root | null = null;

interface GlobalLoadingProps {
	visible: boolean;
}

const GlobalLoadingComponent: React.FC<GlobalLoadingProps> = ({ visible }) => {
	if (!visible) return null;
	return (
		<div className="global-loading">
			<div className="loading-spinner"></div>
		</div>
	);
};

const loadRootNode = () => {
	let existingElement = document.getElementById("loading");
	if (!existingElement) {
		existingElement = document.createElement("div");
		existingElement.id = "loading";
		document.body.appendChild(existingElement);
	}
	return existingElement;
};

export const showGlobalLoading = () => {
	const showLoading = () => {
		const existingElement = loadRootNode();
		try {
			if (!loadingRoot) {
				loadingRoot = ReactDOM.createRoot(existingElement);
			}
			loadingRoot.render(<GlobalLoadingComponent visible={true} />);
		} catch (error) {
			console.error("Error showing loading:", error);
		}
	};

	const hideLoading = () => {
		try {
			if (loadingRoot) {
				loadingRoot.render(<GlobalLoadingComponent visible={false} />);
				const removeLoading = document.getElementById("loading");
				if (removeLoading) {
					document.body.removeChild(removeLoading);
					loadingRoot = null;
				}
			}
		} catch (error) {
			console.error("Error hiding loading:", error);
		}
	};

	return {
		showLoading,
		hideLoading,
	};
};
